import React from "react";
import { basePath } from "@/pages/Login/auth.config";
import styles from "./EnvBadge.module.scss";

const env = import.meta.env.VITE_ENV;
const envLabel: string | null =
  env === "ephemeral"
    ? ((basePath.match(/^\/eph\/([^/]+)\//) ?? [])[1] ?? "ephemeral")
    : env !== "production"
      ? env
      : null;

export const EnvBadge: React.FC = () => {
  if (!envLabel) return null;
  return <span className={styles.badge}>{envLabel}</span>;
};

export const envBadgeWidgetClass = envLabel
  ? styles.widgetWithBadge
  : undefined;
